export default '4.47.0';